import styled from "@emotion/styled";
import CircularProgress from "@mui/material/CircularProgress";

import { fontRoboto } from "shared/lib/styles";
import { theme } from "shared/lib/styles/theme";

import HeaderIcon from "./header-icon.svg";

export const StyledCircularProgress = styled(CircularProgress)`
  margin-block: 12px;
  margin-inline: auto;

  svg {
    color: #eb4254;
  }
`;

export const OuterContainer = styled.div`
  padding: 1px;

  border-radius: 12px;

  background-image: linear-gradient(to right, #eb4254, #4585ff);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  inline-size: 100%;
  block-size: 100%;

  border-radius: 12px;

  background-color: #ffffff;

  box-shadow:
    0 0 1px 0 #ffffff inset,
    0 0 1px 0 #ffffff;
`;

export const HeaderContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  margin-block-start: 12px;
  padding-inline: 20px;
`;

export const StyledHeaderIcon = styled(HeaderIcon)`
  inline-size: 25px;
  block-size: 25px;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;

  background: linear-gradient(to right, #eb4254, #4585ff);
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const NoResult = styled.div`
  padding-block: 12px;
  padding-inline: 16px;

  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 140%;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;

  ${theme.breakpoints.up("tablet")} {
    font-size: 16px;
  }
`;

export const ListContainer = styled.div`
  padding-block: 8px;
`;
